export enum MfaEnforcementStatus {
    ENFORCED = 'Enforced',
    UNENFORCED = 'Unenforced',
    UNKNOWN = 'Unknown',
}
